import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.contact', {
        url: '/contact',
        component: 'contact',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/contact/contact.state.js